import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import home from '@/components/home'
import index from '@/components/index'
import department from '@/components/system/department'
import role from '@/components/system/role'
import user from '@/components/system/user'
import menu from '@/components/system/menu'
import add from '@/components/system/add'
import errors from '@/components/system/404'
import 广告管理 from '@/views/content/advertManage'
import 简介管理 from '@/views/content/introduction/introduction'
import 公司简介 from '@/views/content/introduction/company'

import 关于我们 from '@/views/content/introduction/about'
import 留言管理 from '@/views/content/message/message'
import 留言编辑 from '@/views/content/message/Mupdate'
import 留言参数 from '@/views/content/message/Mparameter'
import 留言参数修改 from '@/views/content/message/pUpdate'
import 内容管理 from '@/views/content/content/content'
import 广告编辑 from '@/views/content/update'
import 商品管理 from '@/views/content/commodity/commodity'
import 商品参数 from '@/views/content/commodity/parameters'
import 商品参数修改 from '@/views/content/commodity/parameterUpdate'
import 商品管理修改 from '@/views/content/commodity/productUpdate'
import 图片管理 from '@/views/content/picManage/picManage'
import 图片管理修改 from '@/views/content/picManage/picUpdate'
import 文章管理 from '@/views/content/article/article'
import 文章管理修改 from '@/views/content/article/artUpdate'
import 下载管理 from '@/views/content/download/download'
import 下载管理修改 from '@/views/content/download/downUpdate'
import 运营管理 from '@/views/operate/operate'
import 友情链接 from '@/views/operate/link'
import 友情链接修改 from '@/views/operate/linkUpdate'
import 手机设置 from '@/views/phone/phone/phone'
import Banner设置 from '@/views/phone/banner/phoneBanner'
import 手机设置add from '@/views/phone/phone/phoneAdd'
import 基本设置 from '@/views/system/system/basicSystem'

import 表单管理 from '@/views/system/form/formManage'
import 表单增加 from '@/views/system/form/formAdd'
import 数据项增加 from '@/views/system/form/dataAdd'
import 表单描述增加 from '@/views/system/form/desAdd'
import 数据项修改 from '@/views/system/form/dataUpdate'
import 表单 from '@/views/content/form/form'
import 表单描述更新 from '@/views/system/form/desUpdate'

import 专题页 from '@/views/system/special/special'
import 专题增加 from '@/views/system/special/specialAdd'
import 专题项 from '@/views/system/special/specialItem'
import 专题项增加 from '@/views/system/special/specialItemAdd'

import 栏目设置 from '@/views/system/column/column'
import 栏目修改 from '@/views/system/column/columnAdd'
import SystemBanner设置 from '@/views/system/systemBanner/systemBanner'
import banner添加 from '@/views/system/systemBanner/systemAdd'
import 应用中心 from '@/views/system/bullet/bullet'
import 应用中心修改 from '@/views/system/bullet/bulletUpdate'
import 应用中心详情 from '@/views/system/bullet/bulletDetail'
import 素材库设置 from '@/views/system/library/library'
import 素材库添加 from '@/views/system/library/addLibray'

import 修改密码 from '@/views/password'
import 修改头像 from '@/views/updateHead'
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'login',
			component: login
		},
		{
			path: '/home',
			component: home,
			children: [{
					path: '/',
					redirect: 'index'
				},
				{
					path: 'index',
					name: 'index',
					component: index,

				},
				{
					path: 'content',
					name: 'content',
					component: 内容管理,
				},
				{
					path: 'content',
					name: 'content',
					component: 内容管理,
				
				},
				{
					path: 'advertManage',
					name: 'advertManage',
					component: 广告管理,
				
				},
				{
					path: 'update',
					name: 'update',
					component: 广告编辑,
				
				},
				{
					path: 'introduction',
					name: 'introduction',
					component: 简介管理,
				
				},
				{
					path: 'company',
					name: 'company',
					component: 公司简介,
				
				},
				{
					path: 'form',
					name: 'form',
					component: 表单,
				
				},
				{
					path: 'about',
					name: 'about',
					component: 关于我们,
				
				},
				{
					path: 'message',
					name: 'message',
					component: 留言管理,
				
				},
				{
					path: 'Mupdate',
					name: 'Mupdate',
					component: 留言编辑,
				
				},
				{
					path: 'Mparameter',
					name: 'Mparameter',
					component: 留言参数,
				
				},
				{
					path: 'pUpdate',
					name: 'pUpdate',
					component: 留言参数修改,
				
				},
				{
					path: 'commodity',
					name: 'commodity',
					component: 商品管理,
				
				},
				{
					path: 'parameters',
					name: 'parameters',
					component: 商品参数,
				
				},
				{
					path: 'parameterUpdate',
					name: 'parameterUpdate',
					component: 商品参数修改,
				
				},
				{
					path: 'productUpdate',
					name: 'productUpdate',
					component: 商品管理修改,
				
				},
				{
					path: 'article',
					name: 'article',
					component: 文章管理,
				
				},
				{
					path: 'artUpdate',
					name: 'artUpdate',
					component: 文章管理修改,
				
				},
				{
					path: 'picManage',
					name: 'picManage',
					component: 图片管理,
				
				},
				{
					path: 'picUpdate',
					name: 'picUpdate',
					component: 图片管理修改,
				
				},
				{
					path: 'download',
					name: 'download',
					component: 下载管理,
				
				},
				{
					path: 'downUpdate',
					name: 'downUpdate',
					component: 下载管理修改,
				
				},{
					path: 'operate',
					name: 'operate',
					component: 运营管理,

				},
				{
					path: 'link',
					name: 'link',
					component: 友情链接,
				
				},
				{
					path: 'linkUpdate',
					name: 'linkUpdate',
					component: 友情链接修改,
				
				},{
					path: 'phone',
					name: 'phone',
					component: 手机设置,

				},
				{
					path: 'phoneAdd',
					name: 'phoneAdd',
					component: 手机设置add,
				
				},
				{
					path: 'phoneBanner',
					name: 'phoneBanner',
					component: Banner设置,
				
				},
				{
					path: 'basicSystem',
					name: 'basicSystem',
					component: 基本设置,

				},
				{
					path: 'formManage',
					name: 'formManage',
					component: 表单管理,

				},
				{
					path: 'formAdd',
					name: 'formAdd',
					component: 表单增加,

				},
				{
					path: 'dataAdd',
					name: 'dataAdd',
					component: 数据项增加,

				},
				{
					path: 'dataUpdate',
					name: 'dataUpdate',
					component: 数据项修改,

				},
				{
					path: 'desAdd',
					name: 'desAdd',
					component: 表单描述增加,

				},
				{
					path: 'desUpdate',
					name: 'desUpdate',
					component: 表单描述更新,

				},
				{
					path: 'special',
					name: 'special',
					component: 专题页,

				},
				{
					path: 'specialAdd',
					name: 'specialAdd',
					component: 专题增加,

				},
				{
					path: 'specialItem',
					name: 'specialItem',
					component: 专题项,

				},
				{
					path: 'specialItemAdd',
					name: 'specialItemAdd',
					component: 专题项增加,

				},
				{
					path: 'systemBanner',
					name: 'systemBanner',
					component: SystemBanner设置,
				
				},
				{
					path: 'systemAdd',
					name: 'systemAdd',
					component: banner添加,
				
				},
				{
					path: 'library',
					name: 'library',
					component: 素材库设置,
				
				},
				{
					path: 'addLibray',
					name: 'addLibray',
					component: 素材库添加,
				
				},
				{
					path: 'column',
					name: 'column',
					component: 栏目设置,
				
				},
				{
					path: 'columnAdd',
					name: 'columnAdd',
					component: 栏目修改,
				
				},
				{
					path: 'bullet',
					name: 'bullet',
					component: 应用中心,
				
				},
				{
					path: 'bulletUpdate',
					name: 'bulletUpdate',
					component: 应用中心修改,
				
				},
				{
					path: 'bulletDetail',
					name: 'bulletDetail',
					component: 应用中心详情,
				
				},
				{
					path: '404',
					name: '404',
					component: errors,

				},
				{
					path: 'password',
					name: 'password',
					component: 修改密码,
				
				},
				{
					path: 'updateHead',
					name: 'updateHead',
					component: 修改头像,
				
				},

			]
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js